import { ILocationDetails } from "./ILocationDetails";
import { IUserDetails } from "./IUsersDetails";

export class IOrdersFacilityProvider {
    facilityId: number;
    providerId: number;
    facilityProviderId: number;
    facilityName: string;
    addressLine1: string;
    addressLine2: string;
    state: string;
    city: string;
    zipCode: string;
    faxNumber: string;
    phoneNumber: string;
    providerFirstName: string;
    providerLastName: string;
    providerNPI: string;
    isActive: boolean;
    createdBy: string;
    createdOn: Date;
    modifiedBy: string;
    modifiedOn: Date;
    providerName: string;
}


export class ICQMSProviderConfiguration {
    facilityId: number;
    providerId: string;
    providerName: string;
    measureId: any;
    measureIds: any;
    masterMeasureId: string;
    measureName: string;
    isActive: boolean;
    createdBy: string;
    createdOn: Date;
    modifiedBy: string;
    modifiedOn: Date;
    selected: boolean;
    measureNames: IMeasures[];
    configurationId: number;
    selectedMeasureNames: string;
    userlocationIds: any;
    providerNPI: string;
    providerTIN: string;
    providerCCN: string;
}
export class MeasuresProviders {
    locationsList: ILocationDetails[];
    userList: IUserDetails[];
    masterConfigList: ICQMSProviderConfiguration[];
    masterMeasuresList: IMeasures[];
}
export interface IMeasures {
    measureId: string;
    measureIdNames: string;
    measureName?: string;
    selected?: boolean;
}